const namespace = 'unit-categories';

export const GET_UNIT_CATEGORIES_PAGINATION = `${namespace}/Pagination Get`;
export const GET_UNIT_CATEGORIES_PAGINATION_SUCCESS = `${namespace}/Pagination Get Success`;
export const GET_UNIT_CATEGORIES_PAGINATION_FAIL = `${namespace}/Pagination Get Fail`;

export const GET_UNIT_CATEGORIES_SINGLE = `${namespace}/Single Get`;
export const GET_UNIT_CATEGORIES_SINGLE_SUCCESS = `${namespace}/Single Get Success`;
export const GET_UNIT_CATEGORIES_SINGLE_FAIL = `${namespace}/Single Get Fail`;